export type TimeUnit =
  | 'year'
  | 'month'
  | 'week'
  | 'day'
  | 'hour'
  | 'minute'
  | 'second';

export interface TimeLeftOptions {
  /**
   * Maximum unit to include (largest).
   * Example: "month" means you will NOT show years.
   */
  maxUnit?: TimeUnit;

  /**
   * Minimum unit to include (smallest).
   * Example: "minute" means you will NOT show seconds.
   */
  minUnit?: TimeUnit;

  /**
   * If true, weeks will be considered between months and days.
   * If false, weeks will never appear (even if max/min range includes it).
   *
   * Default: true
   */
  includeWeeks?: boolean;

  /**
   * Locale name to apply temporarily for formatting.
   * Dayjs supports a global locale via dayjs.locale("es"), etc.
   * If you don't pass this, it will use the current global locale.
   */
  locale?: string;
}
